import React from "react";

class Footer extends React.Component{

render(){

    return(
        <div>
        {/* Footer Starts Here */}
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-md-4 footer-item">
                <h4>Lakshan Associates</h4>
                <p>Here at Lakshan Associates, we welcome all your enquiries on our services. Talk to us today on how you too can contribute towards recycling efforts while making returns for your wastes.</p>
              </div>
              <div className="col-md-4 footer-item">
                <h4>Contact Us</h4>
                <p><i className="fa fa-location-arrow"></i>&nbsp;&nbsp;&nbsp;No.39 Panchayat Road, Mambakkam Village &amp; Post, Sriperumbudur Taluk, Kanchipuram District, Pincode-602106.</p>
                <p><i className="fa fa-phone"></i>&nbsp;&nbsp;&nbsp;8939897239&nbsp;&nbsp;|&nbsp;&nbsp;7299947239</p>
                <p><i className="fa fa-envelope"></i>&nbsp;&nbsp;&nbsp;lakshanassociates@gmail.com</p>
              </div>
              <div className="col-md-4 footer-item last-item">
                <h4>For Enquiries</h4>
                <div className="contact-form">
                  <form id="contact footer-contact" method="post">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea name="message" rows={6} className="form-control" id="message" placeholder="Your Message" required defaultValue={""} />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="filled-button">Send Message</button>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="sub-footer">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <p>Copyright © 2022 Lakshan Associates.
                  - Design &amp; Maintained by : <a rel="noreferrer" href="https://dgiworx.in" target="_blank">DGi WORX</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    )
  }
}

export default Footer;